(function exposeTitanScanData(root, factory) {
  const config = root && root.TitanPlayerScanConfig ? root.TitanPlayerScanConfig : {};
  const runtime =
    root && root.TitanScanRuntime
      ? root.TitanScanRuntime
      : typeof module === 'object' && module.exports
        ? require('./tps-v2-runtime.js')
        : null;
  const data = factory(config, runtime);

  if (typeof module === 'object' && module.exports) {
    module.exports = data;
  }

  if (root) {
    root.TitanScanData = data;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function createTitanScanData(config, runtime) {
  'use strict';

  const assets = config && typeof config.assets === 'object' && config.assets ? config.assets : {};
  const configuredProducts =
    config && typeof config.products === 'object' && config.products ? config.products : {};
  /* ケース(見た目)選択用。Liquid が出力する { 商品ID: [ケース候補...] } をそのまま通す (2026-07-24) */
  const configuredCases =
    config && typeof config.cases === 'object' && config.cases ? config.cases : {};

  function asset(name, fallback) {
    const value = assets[name];
    return runtime && runtime.isShopifyAssetUrl(value)
      ? value
      : fallback;
  }

  function deepFreeze(value) {
    if (!value || typeof value !== 'object' || Object.isFrozen(value)) {
      return value;
    }

    Object.values(value).forEach(deepFreeze);
    return Object.freeze(value);
  }

  function safeProductText(value, fallback) {
    return typeof value === 'string' && value.length > 0 && value.length <= 180 && !/[<>]/.test(value)
      ? value
      : fallback;
  }

  function safeProductUrl(value, fallback) {
    if (typeof value !== 'string' || value.length > 500) return fallback;
    try {
      const parsed = new URL(value, 'https://www.titan-pc.net');
      if (parsed.origin !== 'https://www.titan-pc.net' || !parsed.pathname.startsWith('/products/')) {
        return fallback;
      }
      return parsed.href;
    } catch (error) {
      return fallback;
    }
  }

  function safePrice(value, fallback) {
    const numeric = Number(value);
    return Number.isInteger(numeric) && numeric >= 50000 && numeric <= 1000000
      ? numeric
      : fallback;
  }

  function mergeConfiguredProduct(product) {
    const configured = configuredProducts[product.id];
    if (!configured || typeof configured !== 'object') return product;
    const priceMin = safePrice(configured.priceMin, product.priceMin);
    const priceMax = Math.max(priceMin, safePrice(configured.priceMax, product.priceMax));
    const merged = {
      ...product,
      name: safeProductText(configured.name, product.name),
      image: runtime && runtime.isShopifyAssetUrl(configured.image) ? configured.image : product.image,
      url: safeProductUrl(configured.url, product.url),
      priceMin,
      priceMax,
    };
    return typeof configured.available === 'boolean'
      ? { ...merged, available: configured.available }
      : merged;
  }

  const games = [
    {
      id: 'valorant',
      name: 'VALORANT',
      shortName: 'VALORANT',
      load: 'light',
      baseGpuRank: 1,
      cpuSensitivity: 3,
      qualitySensitivity: 1,
      descriptor: 'HIGH FPS / LOW LATENCY',
    },
    {
      id: 'apex-legends',
      name: 'APEX LEGENDS',
      shortName: 'APEX',
      load: 'medium',
      baseGpuRank: 2,
      cpuSensitivity: 3,
      qualitySensitivity: 2,
      descriptor: 'TRACKING / STABILITY',
    },
    {
      id: 'fortnite',
      name: 'FORTNITE',
      shortName: 'FORTNITE',
      load: 'medium',
      baseGpuRank: 2,
      cpuSensitivity: 3,
      qualitySensitivity: 2,
      descriptor: 'BUILD / HIGH FPS',
    },
    {
      id: 'monster-hunter-wilds',
      name: 'MONSTER HUNTER WILDS',
      shortName: 'MONSTER HUNTER',
      load: 'heavy',
      baseGpuRank: 3,
      cpuSensitivity: 2,
      qualitySensitivity: 3,
      descriptor: 'QUALITY / GPU POWER',
    },
    {
      id: 'minecraft',
      name: 'MINECRAFT',
      shortName: 'MINECRAFT',
      load: 'medium',
      baseGpuRank: 2,
      cpuSensitivity: 2,
      qualitySensitivity: 3,
      descriptor: 'MOD / SHADER',
    },
    {
      id: 'cyberpunk-2077',
      name: 'CYBERPUNK 2077',
      shortName: 'CYBERPUNK 2077',
      load: 'ultra',
      baseGpuRank: 4,
      cpuSensitivity: 2,
      qualitySensitivity: 3,
      descriptor: 'RAY TRACING / 4K',
    },
  ];

  const fallbackProducts = [
    {
      id: 'aqua-3050-black',
      name: 'RTX 3050 / Ryzen 5 5500 — AQUA UNO BLACK',
      gpu: 'GeForce RTX 3050',
      gpuRank: 1,
      cpu: 'Ryzen 5 5500',
      memory: 16,
      priceMin: 122000,
      priceMax: 122000,
      gameLoad: ['light', 'medium'],
      targetHz: 144,
      image: asset('aquaUno', 'assets/products/aqua-uno-black-900.webp'),
      url: 'https://www.titan-pc.net/products/aqua-bk-rtx3050',
      isNew: true,
      caseColor: 'Black',
      description: 'フルHDの入門構成。軽量タイトルと60〜144Hz環境に合わせやすい一台。',
    },
    {
      id: 'aqua-4060-black',
      name: 'RTX 4060 / Ryzen 5 5500 — AQUA UNO BLACK',
      gpu: 'GeForce RTX 4060',
      gpuRank: 2,
      cpu: 'Ryzen 5 5500',
      memory: 16,
      priceMin: 137000,
      priceMax: 137000,
      gameLoad: ['light', 'medium'],
      targetHz: 144,
      image: asset('aquaUno', 'assets/products/aqua-uno-black-900.webp'),
      url: 'https://www.titan-pc.net/products/aqua-bk-rtx4060-ryzen7-3700x',
      isNew: false,
      caseColor: 'Black',
      description: 'フルHD高FPSと価格のバランスを取りやすいGPU構成。',
    },
    {
      id: 'h17-5060-black',
      name: 'RTX 5060 / Ryzen 5 5500 — H17',
      gpu: 'GeForce RTX 5060',
      gpuRank: 3,
      cpu: 'Ryzen 5 5500',
      memory: 16,
      priceMin: 150000,
      priceMax: 150000,
      gameLoad: ['light', 'medium', 'heavy'],
      targetHz: 240,
      image: asset('h17', 'assets/products/h17-black-900.webp'),
      url: 'https://www.titan-pc.net/products/h17-rtx5060',
      isNew: true,
      caseColor: 'Black',
      description: '高FPS対戦タイトルを中心に、フルHDで余裕を持たせる新品GPU構成。',
    },
    {
      id: 'aqua-5060ti8-black',
      name: 'RTX 5060 Ti 8GB / Ryzen 5 5500 — AQUA UNO BLACK',
      gpu: 'GeForce RTX 5060 Ti 8GB',
      gpuRank: 3,
      cpu: 'Ryzen 5 5500',
      memory: 16,
      priceMin: 164000,
      priceMax: 164000,
      gameLoad: ['light', 'medium', 'heavy'],
      targetHz: 240,
      image: asset('aquaUno', 'assets/products/aqua-uno-black-900.webp'),
      url: 'https://www.titan-pc.net/products/aqua-bk-rtx5060ti8',
      isNew: true,
      caseColor: 'Black',
      description: 'RTX 5060より描画余力を増やし、高FPSと高画質の両方を狙う構成。',
    },
    {
      id: 'aqua-5070-black',
      name: 'RTX 5070 / Ryzen 7 7700 — AQUA UNO BLACK',
      gpu: 'GeForce RTX 5070',
      gpuRank: 4,
      cpu: 'Ryzen 7 7700',
      memory: 16,
      priceMin: 260000,
      priceMax: 260000,
      gameLoad: ['medium', 'heavy', 'ultra'],
      targetHz: 240,
      image: asset('aquaUno', 'assets/products/aqua-uno-black-900.webp'),
      url: 'https://www.titan-pc.net/products/aqua-bk-rtx5070',
      isNew: true,
      caseColor: 'Black',
      description: 'WQHDと高FPSを両立しやすい、Ryzen 7搭載の上位構成。',
    },
    {
      id: 'elite-5070ti-black',
      name: 'RTX 5070 Ti / Ryzen 7 7700 — ELITE 681 BLACK',
      gpu: 'GeForce RTX 5070 Ti',
      gpuRank: 5,
      cpu: 'Ryzen 7 7700',
      memory: 16,
      priceMin: 338000,
      priceMax: 338000,
      gameLoad: ['heavy', 'ultra'],
      targetHz: 240,
      image: asset('elite681', 'assets/products/elite-681-black-900.webp'),
      url: 'https://www.titan-pc.net/products/elite-681-bk-rtx5070ti-ryzen7-7700',
      isNew: true,
      caseColor: 'Black',
      description: 'WQHD最高画質や4Kを視野に入れる、GPU優先のハイエンド構成。',
    },
    {
      id: 'o11-5080-black',
      name: 'RTX 5080 / Ryzen 7 7700 — NeoPrism ブラック',
      gpu: 'GeForce RTX 5080',
      gpuRank: 6,
      cpu: 'Ryzen 7 7700',
      memory: 16,
      priceMin: 407000,
      priceMax: 407000,
      gameLoad: ['heavy', 'ultra'],
      targetHz: 360,
      image: asset('o11Vision', 'assets/products/o11-vision-black-900.webp'),
      url: 'https://www.titan-pc.net/products/o11vc-bk-rtx5080',
      isNew: true,
      caseColor: 'Black',
      description: '4K高画質と重量級タイトル向け。診断予算上限を超える比較用モデル。',
    },
  ];
  const products = fallbackProducts.map(mergeConfiguredProduct);

  return deepFreeze({
    schemaVersion: 1,
    catalogUpdated: '2026-07-13',
    games,
    products,
    cases: configuredCases,
    styles: ['casual', 'ranked', 'competitive'],
    monitorOptions: [60, 144, 240, 360],
    priorities: ['fps', 'balanced', 'quality'],
    streamingOptions: ['none', 'occasional', 'serious'],
    inputModes: ['mouse', 'touch'],
    screens: [
      'intro',
      'game',
      'profile',
      'preferences',
      'input-intro',
      'input-test',
      'reaction-intro',
      'reaction-test',
      'analyzing',
      'result',
    ],
    labels: {
      styles: {
        casual: 'CASUAL',
        ranked: 'RANKED',
        competitive: 'COMPETITIVE',
      },
      priorities: {
        fps: 'FPS最優先',
        balanced: 'バランス',
        quality: '画質最優先',
      },
      streaming: {
        none: 'しない',
        occasional: 'たまにする',
        serious: '本格的にする',
      },
    },
  });
});
